module.exports = __webpack_public_path__ + "img/5.266a7ccc.jpg";